import React, { Component } from "react";
import { Fragment } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Modal, Table } from 'antd';
import offImage from './images/off.png';
import Loading from "./loader";
import VoteSave from "./voteSave";
import * as math from 'mathjs';
import QuestionNavigator from './QuestionNavigator';
import ScrollUpButton from "react-scroll-up-button";

class VoteActive extends Component {
  unblock = null;

  state = {
    detailsVisible: [],
    mainMeeting: [],
    agenda: [],
    questionDetail: {},
    voteCount: [],
    isLoading: true,
    inputValues: {},
    votes: {},
    showScrollUp: false,
    isFormDirty: false,
    isOverlapped: false,
    labelsLeft: 0,
    columnWidths: [80, 80, 80]
  };

  async componentDidMount() {
    const { match, history } = this.props;
    const meetingId = match.params.meetingId;
    const selectedAccountId = match.params.selectedAccountId;
    const selectedUniquifier = match.params.selectedUniquifier;

    window.addEventListener('scroll', this.handleScroll);

    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const regCheckRes = await fetch(
      `${API_ADDRESS}reg_status/${meetingId}/${selectedAccountId}/${selectedUniquifier}/`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    if (!regCheckRes.ok || !(await regCheckRes.json()).is_registered) {
      alert("Доступ запрещён: вы не зарегистрированы на это собрание.");
      this.props.history.push("/");
      return;
    }

    // Получаем данные бюллетеня
    const serverTime = await this.getServerTime();
    const userRes = await fetch(`${API_ADDRESS}get_vote_anketa/${meetingId}/${selectedAccountId}/${selectedUniquifier}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (userRes.ok) {
      const AnketaData = await userRes.json();
      const sortedAgenda = [...AnketaData.agenda].sort((a, b) => {
        return parseInt(a.question_id, 10) - parseInt(b.question_id, 10);
      });
      const mainMeeting = AnketaData.mainMeeting;

      const meetingOpenDate = new Date(mainMeeting.meeting_open);
      const meetingCloseDate = new Date(mainMeeting.meeting_close);
      const meetingDate = new Date(mainMeeting.meeting_date);
      const status = mainMeeting.status;

      const isSameDate = (date1, date2) => {
        return (
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        );
      };

      const serverDateOnly = new Date(serverTime);
      serverDateOnly.setHours(0, 0, 0, 0);
      const meetingDateOnly = new Date(meetingDate);
      meetingDateOnly.setHours(0, 0, 0, 0);
      const isMeetingDateValid = isSameDate(serverDateOnly, meetingDateOnly);

      if (
        serverTime >= meetingOpenDate &&
        serverTime <= meetingCloseDate &&
        status === 3 &&
        isMeetingDateValid
      ) {
        this.setState({
          agenda: sortedAgenda,
          voteCount: AnketaData.voteCount,
          mainMeeting: mainMeeting,
          isLoading: false,
          votes: this.processVoteCount(AnketaData.voteCount),
          email: AnketaData.email
        }, () => {
          this.setupObserver();
          this.updateColumnWidths();
          window.addEventListener('resize', this.updateColumnWidths);
        });
      } else {
        alert("Голосование недоступно. Проверьте дату или время начала голосования.");
        this.props.history.push("/");
        return;
      }
    } else {
      this.setState({ isLoading: false });
      alert("Произошла ошибка. Попробуйте ещё раз начать голосование.");
      this.props.history.goBack();
    }

    if (userRes.statusText === "Unauthorized") {
      alert("Время сессии истекло. Пожалуйста, выполните вход.");
      document.getElementById("logoutBttn")?.click();
    }

    // Блокировка навигации при изменении формы
    this.unblock = this.props.history.block((location, action) => {
      if (['PUSH', 'POP'].includes(action) && this.state.isFormDirty) {
        Modal.confirm({
          title: 'Вы покидаете страницу с голосованием',
          content: 'Ваши действия на форме не сохранятся. Вы действительно хотите покинуть страницу?',
          okText: 'Да',
          okType: 'default',
          cancelText: 'Нет',
          onOk: () => {
            this.unblock();
            this.props.history.push(location);
          },
          onCancel() {
            // остаёмся
          },
        });
        return false;
      }
      return true;
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  async getServerTime() {
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const response = await fetch(`${API_ADDRESS}get_server_time/`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return new Date(data.server_time);
    } else {
      console.error('Ошибка при получении серверного времени');
      return null;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('resize', this.updateColumnWidths);
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.unblock) {
      this.unblock();
    }
  }

  setTableAnchorRef = (element) => {
    this.tableAnchorRef = element;
  };

  checkButtonState = () => {
    const { votes, inputValues, agenda, questionDetail } = this.state;
    let isEnabled = true;
    agenda.forEach(item => {
      const isCumulativeQuestion = item.cumulative;
      const hasDetails = questionDetail[item.question_id] && questionDetail[item.question_id].length > 0;
      const questionId = item.question_id;

      if (!isCumulativeQuestion && item.seat_count === 0) {
        const anyCheckboxChecked = votes[questionId] && Object.keys(votes[questionId]).length > 0;
        if (!anyCheckboxChecked) {
          isEnabled = false;
        }
      }

      if (isCumulativeQuestion) {
        const anyInputValue = inputValues[questionId] && Object.values(inputValues[questionId]).some(value => value > 0);
        const anyCheckboxChecked = votes[questionId] && Object.keys(votes[questionId]).length > 0;
        if (!anyInputValue && !anyCheckboxChecked) {
          isEnabled = false;
        }
      }

      if (hasDetails) {
        const allDetailsChecked = questionDetail[questionId]?.every(detail => {
          const detailId = detail.detail_id;
          return (
            votes[questionId]?.[detailId] ||
            (inputValues[questionId]?.[detailId] && parseFloat(inputValues[questionId][detailId]) > 0)
          );
        });
        if (!allDetailsChecked) {
          isEnabled = false;
        }
      }
    });
  };

  parseMixedNumber = (value) => {
    if (typeof value === 'string') {
      const parts = value.split(/\s+/);
      let total = 1;
      for (const part of parts) {
        if (part.includes('/')) {
          const [numerator, denominator] = part.split('/');
          if (!denominator || isNaN(numerator) || isNaN(denominator) || parseFloat(denominator) === 0) {
            return NaN;
          }
          total *= parseFloat(numerator) / parseFloat(denominator);
        } else {
          const parsedPart = parseFloat(part);
          if (!isNaN(parsedPart)) {
            total *= parsedPart;
          }
        }
      }
      return total;
    }
    return parseFloat(value) || 0;
  };

  formatMixedNumber = (numericValue) => {
    const wholePart = Math.floor(numericValue);
    const fractionPart = numericValue - wholePart;
    if (fractionPart > 0) {
      try {
        const fraction = math.fraction(fractionPart);
        return `${wholePart} ${fraction.n}/${fraction.d}`.trim();
      } catch (error) {
        console.error("Ошибка при преобразовании дроби:", error);
        return `${wholePart}`;
      }
    }
    return `${wholePart}`;
  };

  extractVoteQuantity = (questionId) => {
    const { voteCount } = this.state;
    let quantity = null;
    voteCount.forEach(vote => {
      if (vote.json_quantity && vote.json_quantity.VoteDtls) {
        vote.json_quantity.VoteDtls.VoteInstrForAgndRsltn.forEach(instr => {
          if (instr.VoteInstr.QuestionId === questionId) {
            quantity = instr.VoteInstr.Quantity;
          }
        });
      }
    });
    return quantity;
  };

  processVoteCount(voteCount) {
    const votesResult = {};
    voteCount.forEach(item => {
      const voteDetails = item.json_quantity.VoteDtls.VoteInstrForAgndRsltn;
      voteDetails.forEach(vote => {
        const { Quantity, DetailId, QuestionId } = vote.VoteInstr;
        if (!votesResult[QuestionId]) {
          votesResult[QuestionId] = {};
        }
        votesResult[QuestionId][DetailId] = [vote.VoteInstr.Vote, Quantity];
      });
    });
    return votesResult;
  }

  getCumulativeCount = (questionId) => {
    const { voteCount } = this.state;
    for (const vote of voteCount) {
      if (vote.json_quantity && vote.json_quantity.VoteDtls) {
        const { VoteInstrForAgndRsltn } = vote.json_quantity.VoteDtls;
        for (const item of VoteInstrForAgndRsltn) {
          if (item.VoteInstr.QuestionId === questionId) {
            const { Quantity, Numerator, Denominator } = item.VoteInstr;
            if (Numerator === undefined && Denominator === undefined) {
              return `${Quantity}`;
            }
            if (Numerator !== undefined && Denominator !== undefined && Quantity === undefined) {
              return `${Numerator}/${Denominator}`;
            }
            if (Numerator !== undefined && Denominator !== undefined && Quantity !== undefined) {
              return `${Quantity} ${Numerator}/${Denominator}`;
            }
          }
        }
      }
    }
    return '0';
  };

  getParsedCumulativeCount = (questionId) => {
    const cumulativeCount = this.getCumulativeCount(questionId);
    return this.parseMixedNumber(cumulativeCount);
  };

  getFormattedVoteQuantity = (questionId) => {
    const { voteCount } = this.state;
    let result = null;
    voteCount.forEach(vote => {
      if (vote.json_quantity && vote.json_quantity.VoteDtls) {
        vote.json_quantity.VoteDtls.VoteInstrForAgndRsltn.forEach(instr => {
          if (instr.VoteInstr.QuestionId === questionId) {
            const { Quantity, Numerator, Denominator } = instr.VoteInstr;
            if (Numerator !== undefined && Denominator !== undefined) {
              if (Quantity !== undefined) {
                result = `${Quantity} ${Numerator}/${Denominator}`;
              } else {
                result = `${Numerator}/${Denominator}`;
              }
            } else if (Quantity !== undefined) {
              result = `${Quantity}`;
            }
          }
        });
      }
    });
    return result || '0';
  };

  handleCheckboxChange = (questionId, value) => {
    const quantity = this.getFormattedVoteQuantity(questionId);
    this.setState(prevState => {
      const newVotes = { ...prevState.votes };
      if (newVotes[questionId] && newVotes[questionId][0] === value) {
        delete newVotes[questionId];
      } else {
        newVotes[questionId] = [value, quantity];
      }
      return { votes: newVotes };
    }, () => {
      this.setState({ isFormDirty: true });
      this.checkButtonState();
    });
  };

  handleAdditionalCheckboxChange = (questionId, detailId, value) => {
    this.setState(prevState => {
      const newVotes = { ...prevState.votes };
      if (!newVotes[questionId]) {
        newVotes[questionId] = {};
      }
      let quantity = newVotes[questionId][detailId]?.[1];
      if (!quantity && !prevState.votes[questionId]?.[detailId]) {
        const voteItem = prevState.voteCount.find(vote =>
          vote.json_quantity?.VoteDtls?.VoteInstrForAgndRsltn?.some(
            instr => instr.VoteInstr.QuestionId === questionId
          )
        );
        if (voteItem) {
          const instr = voteItem.json_quantity.VoteDtls.VoteInstrForAgndRsltn.find(
            instr => instr.VoteInstr.QuestionId === questionId
          );
          quantity = instr?.VoteInstr?.Quantity || 0;
        }
      }
      if (newVotes[questionId][detailId]?.[0] === value) {
        delete newVotes[questionId][detailId];
      } else {
        newVotes[questionId][detailId] = [value, quantity];
      }
      return { votes: newVotes };
    }, () => {
      this.setState({ isFormDirty: true }, this.checkButtonState);
    });
  };

  toggleDetail = async (questionId) => {
    const { detailsVisible } = this.state;
    const currentlyVisible = detailsVisible[questionId];
    this.setState(prevState => ({
      detailsVisible: {
        ...prevState.detailsVisible,
        [questionId]: !currentlyVisible
      },
      loading: true
    }));

    if (!currentlyVisible) {
      const { match } = this.props;
      const meetingId = match.params.meetingId;
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      try {
        const response = await fetch(`${API_ADDRESS}get_cumulatives/${meetingId}/${questionId}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (response.ok) {
          const questionsData = await response.json();
          const sortedQuestionDetail = [...questionsData.questionDetail].sort(
            (a, b) => a.detail_id - b.detail_id
          );
          this.setState(prevState => ({
            questionDetail: {
              ...prevState.questionDetail,
              [questionId]: sortedQuestionDetail,
            },
            loading: false,
          }));
        }
      } catch (e) {
        console.error(e);
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  };

  handleBlur = (questionId, detailId, value) => {
    if (value.includes('/') && !value.split('/')[1].trim()) {
      alert("Знаменатель не может быть пустым");
      this.setState(prevState => ({
        inputValues: {
          ...prevState.inputValues,
          [questionId]: {
            ...(prevState.inputValues[questionId] || {}),
            [detailId]: '',
          },
        },
        votes: {
          ...prevState.votes,
          [questionId]: {
            ...(prevState.votes[questionId] || {}),
            [detailId]: undefined,
          },
        },
      }), () => {
        this.checkInputSum(questionId);
        this.checkButtonState();
      });
    }
  };

  handleInputChange = (questionId, detailId, e) => {
    const { value } = e.target;
    const { inputValues } = this.state;
    const cumulativeCount = this.getParsedCumulativeCount(questionId);

    if (/^\d*\s?\d*\/?\d*$/.test(value) || value === '') {
      if (value.includes('/0')) {
        alert("Деление на 0 невозможно");
        this.setState(prevState => ({
          inputValues: {
            ...prevState.inputValues,
            [questionId]: {
              ...(prevState.inputValues[questionId] || {}),
              [detailId]: '',
            },
          },
          votes: {
            ...prevState.votes,
            [questionId]: {
              ...(prevState.votes[questionId] || {}),
              [detailId]: undefined,
            },
          },
        }), () => {
          this.checkInputSum(questionId);
          this.checkButtonState();
        });
        return;
      }

      if (value.endsWith('/')) {
        this.setState(prevState => ({
          inputValues: {
            ...prevState.inputValues,
            [questionId]: {
              ...(prevState.inputValues[questionId] || {}),
              [detailId]: value,
            },
          },
          votes: {
            ...prevState.votes,
            [questionId]: {
              ...(prevState.votes[questionId] || {}),
              [detailId]: value,
              cumulative: "cumulative",
            },
          },
        }));
        return;
      }

      let numericValue = this.parseMixedNumber(value);
      if (isNaN(numericValue) || numericValue < 0) return;

      const currentSum = Object.values(inputValues[questionId] || {})
        .reduce((sum, val) => sum + this.parseMixedNumber(val || 0), 0);
      const previousValue = this.parseMixedNumber(inputValues[questionId]?.[detailId] || 0);
      const newSum = currentSum - previousValue + numericValue;

      if (newSum > cumulativeCount) {
        alert(`Сумма голосов превышает доступные ${this.getCumulativeCount(questionId)}`);
        numericValue = Math.max(0, cumulativeCount - (currentSum - previousValue));
      }

      const formattedValue = this.formatMixedNumber(numericValue);

      if (numericValue === 0 || value === '') {
        this.setState(prevState => ({
          inputValues: {
            ...prevState.inputValues,
            [questionId]: {
              ...(prevState.inputValues[questionId] || {}),
              [detailId]: undefined,
            },
          },
          votes: {
            ...prevState.votes,
            [questionId]: {
              ...(prevState.votes[questionId] || {}),
              [detailId]: undefined,
            },
          },
        }), () => {
          this.checkInputSum(questionId);
          this.checkButtonState();
        });
      } else {
        this.setState(prevState => ({
          inputValues: {
            ...prevState.inputValues,
            [questionId]: {
              ...(prevState.inputValues[questionId] || {}),
              [detailId]: formattedValue,
            },
          },
          votes: {
            ...prevState.votes,
            [questionId]: {
              ...(prevState.votes[questionId] || {}),
              [detailId]: numericValue,
              cumulative: "cumulative",
            },
          },
        }), () => {
          this.checkInputSum(questionId);
          this.checkButtonState();
        });
      }
    }
  };

  checkInputSum = (questionId) => {
    const { inputValues } = this.state;
    const cumulativeCount = this.getParsedCumulativeCount(questionId);
    const totalSum = Object.values(inputValues[questionId] || {}).reduce((sum, num) => {
      return sum + this.parseMixedNumber(num);
    }, 0);

    if (totalSum > cumulativeCount) {
      alert(`Число/Сумма превышает ${this.getCumulativeCount(questionId)}`);
      const entries = Object.entries(inputValues[questionId] || {});
      entries.sort((a, b) => this.parseMixedNumber(b[1]) - this.parseMixedNumber(a[1]));
      let remaining = cumulativeCount;
      const updatedValues = {};
      for (const [key, value] of entries) {
        const parsedValue = this.parseMixedNumber(value);
        const allocated = Math.min(parsedValue, remaining);
        updatedValues[key] = this.formatMixedNumber(allocated);
        remaining -= allocated;
        if (remaining <= 0) break;
      }
      this.setState(prevState => ({
        inputValues: {
          ...prevState.inputValues,
          [questionId]: {
            ...updatedValues,
          },
        },
      }));
    }
  };

  highlightRow = (questionId) => {
    const row = document.getElementById(`question-${questionId}`);
    if (row) {
      row.classList.add('blink-animation');
      setTimeout(() => {
        row.classList.remove('blink-animation');
      }, 1000);
    }
  };

  handleScroll = () => {
    const showScrollUp = window.scrollY > 130;
    this.setState({ showScrollUp });
  };

  handleBackClick = () => {
    this.props.history.goBack();
  };

  handleBeforeUnload = (e) => {
    if (this.state.isFormDirty) {
      e.preventDefault();
      e.returnValue = '';
    }
  };

  setupObserver = () => {
    if (!this.tableAnchorRef) return;
    if (this.observer) this.observer.disconnect();
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        this.setState({ isOverlapped: !entry.isIntersecting });
      },
      {
        threshold: 0,
        rootMargin: '-80px 0px 0px 0px',
      }
    );
    this.observer.observe(this.tableAnchorRef);
  };

  updateColumnWidths = () => {
    const headers = document.querySelectorAll('.table-checkbox thead th.checkbox-column');
    if (headers.length === 3) {
      const rects = Array.from(headers).map(el => el.getBoundingClientRect());
      this.setState({
        columnWidths: rects.map(r => r.width),
        labelsLeft: rects[0].left,
      });
    }
  };

  render() {
    const { mainMeeting, agenda, questionDetail, voteCount, detailsVisible, isLoading, inputValues } = this.state;
    if (isLoading) {
      return <Loading />;
    }

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
      const formattedDate = date.toLocaleString('ru-RU', options);
      return formattedDate.replace(/ GMT.*/, '').replace(' года', '').trim();
    };

    return (
      <>
        <div className="page-container">
          <div className="header-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <div className="back-button-wrapper" onClick={this.handleBackClick}>
                <ArrowLeftOutlined
                  style={{ fontSize: '20px', cursor: 'pointer', marginTop: '4px' }}
                />
              </div>
              <h1>Голосование</h1>
            </div>
          </div>

          <div className="grid-container2">
            <p style={{ textAlign: 'center' }}><b>{mainMeeting.meeting_name}</b></p>
            <p style={{ textAlign: 'center', marginTop: '0' }}>
              <b>Акционерное общество "Ведение реестров компаний"</b>
            </p>

            <div className="row1">
              <label htmlFor="endDate">Дата, время окончания приёма бюллетеней:</label>
              <span className="whiteBox"><b>{formatDate(mainMeeting.deadline_date)} мск</b></span>
            </div>

            <span
              ref={this.setTableAnchorRef}
              style={{ display: 'inline-block', width: 0, height: 1 }}
            />

            <table className="table-checkbox">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th className="checkbox-column">За</th>
                  <th className="checkbox-column">Против</th>
                  <th className="checkbox-column">Воздержался</th>
                </tr>
              </thead>
              <tbody>
                {agenda.map((item, index) => (
                  <Fragment key={item.question_id}>
                    <tr id={`question-${item.question_id}`}>
                      <td>{index + 1}</td>
                      <td>
                        <div style={{
                          marginTop: '10px',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center'
                        }}>
                          {item.cumulative && (
                            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
                              <span>Количество кумулятивных голосов: </span>
                              <span className="greyBox" style={{ marginLeft: '5px' }}>
                                <b>{this.getCumulativeCount(item.question_id)}</b>
                              </span>
                            </div>
                          )}
                        </div>
                        <div style={{ marginTop: '15px' }}>
                          <i><b>Вопрос:</b></i> {item.question}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                          <i><b>Решение:</b></i> {item.decision}
                        </div>
                        {(item.cumulative || (item.cumulative === false && item.seat_count > 0)) && (
                          <img
                            src={offImage}
                            alt={detailsVisible[item.question_id] ? 'Скрыть' : 'Развернуть'}
                            onClick={() => this.toggleDetail(item.question_id)}
                            className={`toggle-icon ${detailsVisible[item.question_id] ? 'rotated' : ''}`}
                            style={{ marginLeft: '5px', marginTop: '10px' }}
                          />
                        )}<br />
                      </td>
                      <td className="checkbox-column">
                        {item.cumulative ? null : (
                          <input
                            type="checkbox"
                            checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'За'}
                            onChange={() => this.handleCheckboxChange(item.question_id, 'За')}
                            disabled={(item.cumulative === false && item.seat_count > 0)}
                          />
                        )}
                      </td>
                      <td className="checkbox-column">
                        <input
                          type="checkbox"
                          checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'Против'}
                          onChange={() => this.handleCheckboxChange(item.question_id, 'Против')}
                          disabled={(item.cumulative === false && item.seat_count > 0)}
                        />
                      </td>
                      <td className="checkbox-column">
                        <input
                          type="checkbox"
                          checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'Воздержался'}
                          onChange={() => this.handleCheckboxChange(item.question_id, 'Воздержался')}
                          disabled={(item.cumulative === false && item.seat_count > 0)}
                        />
                      </td>
                    </tr>

                    {item.cumulative && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                      questionDetail[item.question_id].map((detail, detailIndex) => (
                        <tr key={detailIndex}>
                          <td></td>
                          <td style={{ paddingLeft: '100px' }}>{detail.detail_text}</td>
                          <td className="checkbox-column">
                            <input
                              type="text"
                              className='main-input7'
                              value={inputValues[item.question_id]?.[detail.detail_id] || ''}
                              onChange={(e) => {
                                const { value } = e.target;
                                if (/^\d*\s?\d*\/?\d*$/.test(value) || value === '') {
                                  this.handleInputChange(item.question_id, detail.detail_id, e);
                                }
                              }}
                              onBlur={(e) => {
                                const { value } = e.target;
                                this.handleBlur(item.question_id, detail.detail_id, value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === ' ') {
                                  e.preventDefault();
                                  const currentValue = e.target.value;
                                  if (/^\d+$/.test(currentValue)) {
                                    e.target.value = `${currentValue} /`;
                                    this.handleInputChange(item.question_id, detail.detail_id, { target: { value: e.target.value } });
                                  }
                                }
                              }}
                              min="0"
                              disabled={
                                (this.state.votes[item.question_id]?.[0] === 'Против' ||
                                  this.state.votes[item.question_id]?.[0] === 'Воздержался') && item.cumulative
                              }
                            />
                          </td>
                        </tr>
                      ))
                    )}

                    {item.cumulative === false && item.seat_count > 0 && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                      questionDetail[item.question_id].map((detail, detailIndex) => (
                        <tr key={detailIndex}>
                          <td></td>
                          <td style={{ paddingLeft: '100px' }}>{detail.detail_text}</td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'За'}
                              onChange={() => this.handleAdditionalCheckboxChange(item.question_id, detail.detail_id, 'За')}
                            />
                          </td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'Против'}
                              onChange={() => this.handleAdditionalCheckboxChange(item.question_id, detail.detail_id, 'Против')}
                            />
                          </td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'Воздержался'}
                              onChange={() => this.handleAdditionalCheckboxChange(item.question_id, detail.detail_id, 'Воздержался')}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>

            <QuestionNavigator
              questions={agenda}
              onQuestionClick={this.highlightRow}
              showScrollUp={this.state.showScrollUp}
            />

            <div className="button-container5">
              <VoteSave
                votes={this.state.votes}
                meeting={this.state.mainMeeting}
                userEmail={this.state.email}
                selectedAccountId={this.props.match.params.selectedAccountId}
                selectedUniquifier={this.props.match.params.selectedUniquifier}
                onVoteSubmitted={() => this.setState({ isFormDirty: false })}
                unblock={this.unblock}
              />
            </div>
          </div>

          <ScrollUpButton />

          {this.state.isOverlapped && (
            <div className="floating-labels">
              <div
                className="floating-label show"
                style={{
                  width: `${this.state.columnWidths[0] - 10}px`,
                  left: `${this.state.labelsLeft + 5}px`,
                }}
              >
                За
              </div>
              <div
                className="floating-label show"
                style={{
                  width: `${this.state.columnWidths[1] - 10}px`,
                  left: `${this.state.labelsLeft + this.state.columnWidths[0] + 5}px`,
                }}
              >
                Против
              </div>
              <div
                className="floating-label show"
                style={{
                  width: `${this.state.columnWidths[2] - 10}px`,
                  left: `${
                    this.state.labelsLeft +
                    this.state.columnWidths[0] +
                    this.state.columnWidths[1] +
                    5
                  }px`,
                }}
              >
                Воздержался
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default VoteActive;